const initialState = {
  selectedCity: JSON.parse(localStorage.getItem('selectedCity')) || null,
  trendingEvents: [],
  primaryEvents: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type){
  case 'SELECTED_CITY:DATA:SET':
    return {
      ...state,
      selectedCity: data,
    }
  case 'TRENDING_EVENT_FILTERS:SET':
    return {
      ...state,
      trendingEvents:data,
    }
  case 'PRIMARY_TRENDING_EVENTS:SET':
    return {
      ...state,
      primaryEvents: data,
    }
  default:
    return state
  }
}